// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  /* Input */
  --icon-color: var(--color-black);
  /* Style */
  display: block;
  position: relative;
  width: 24px;
  height: 24px;
}

.svg-icon {
  width: 100%;
  height: 100%;
  background-color: var(--icon-color);
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/icon/icon.component.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,gCAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;EAEA,WAAA;EACA,YAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,mCAAA;AAAF","sourcesContent":[":host {\n  /* Input */\n  --icon-color: var(--color-black);\n  /* Style */\n  display: block;\n  position: relative;\n  // default size, can be overridden\n  width: 24px;\n  height: 24px;\n}\n\n.svg-icon {\n  width: 100%;\n  height: 100%;\n  background-color: var(--icon-color);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
